import { PurchaseOrderStatus } from 'src/models/enums/PurchaseOrderStatus.enum';
import { CustomerStatus } from 'src/models/enums/CustomerStatus.enum';
import { BankStatus } from 'src/models/enums/BankStatus.enum';
import { GRNStatus, GRNPaymentStatus } from 'src/models/enums/GRNStatus.enum';
import { PaymentMode } from 'src/models/enums/PaymentMode.enum';
import { GRNFormItem } from 'src/models/Management.interface';

export const createEmptyGRNItem = (): GRNFormItem => ({
  rawMaterialId: '',
  receivedQty: '',
  returnedQty: '',
  unitPrice: '',
  id: Date.now().toString(),
  isNew: true,
});

export const getDefaultGRNItems = (): GRNFormItem[] => [createEmptyGRNItem()];

export const loginInitialValues = {
  email: '',
  password: '',
};

export const signupInitialValues = {
  email: '',
  companyName: '',
  companyReg: '',
  companyCountry: '',
  addressLine1: '',
  addressLine2: '',
  postalCode: '',
  city: '',
  firstName: '',
  lastName: '',
  countryCode: '94',
  phoneNumber: '',
  phone: '',
  password: '',
  repassword: '',
};

export const addUserInitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  role: [],
};

export const editUserInitialValues = {
  email: '',
  firstName: '',
  lastName: '',
  role: [] as string[],
};

export const vendorInitialValues = {
  organizationName: '',
  address: '',
  contactPersonName: '',
  countryCode: '94',
  phoneNumber: '',
  email: '',
};

export const rawMaterialInitialValues = {
  name: '',
  code: '',
  minLevelQty: null,
  unit: '',
  unitPrice: '',
  rawMaterialCategoryId: '',
};

export const rawMaterialCategoryInitialValues = {
  name: '',
};

export const productInitialValues = {
  name: '',
  unit: '',
  unitPrice: '',
  displayOrder: null as number | null,
};

export const resetQuantityInitialValues = {
  quantity: '',
};

export const bankInitialValues = {
  bankName: '',
  branchName: '',
  accountName: '',
  accountNumber: '',
  accountType: '',
  status: BankStatus.ACTIVE,
};

export const voucherTypeInitialValues = {
  name: '',
  displayOrder: null as number | null,
  description: '',
};

export const discountInitialValues = {
  name: '',
  description: '',
  percentage: null,
  defaultValue: null,
};

export const surchargeInitialValues = {
  name: '',
  description: '',
  percentage: null,
  defaultValue: null,
};

export const customerInitialValues = {
  name: '',
  customerCode: '',
  organizationName: '',
  countryCode: '94',
  telephoneNo: '',
  email: '',
  status: CustomerStatus.ACTIVE,
  reason: '',
};

export const customerAddressInitialValues = {
  id: '',
  contactPersonName: '',
  contactNo: '',
  countryCode: '94',
  addressLine1: '',
  addressLine2: '',
  city: '',
  country: 'Sri Lanka',
  postCode: '',
  isDefault: false,
};

export const purchaseOrderInitialValues = {
  id: '',
  createdAt: new Date().toLocaleDateString('en-GB'),
  vendor: '',
  deliveryAddress: '',
  status: PurchaseOrderStatus.NEW,
  preparedBy: '',
  approvedBy: '',
  approvedDate: new Date().toLocaleDateString('en-GB') as string | null,
  notes: null,
  purchaseOrderItems: [
    {
      id: '',
      name: '',
      rawMaterialId: '',
      requestedQty: 0,
      approvedQty: 0,
    },
  ],
};

export const orderFilterInitialValues = {
  vendorPicker: '',
  statusPicker: '',
  startDate: null,
  endDate: null,
};

export const voucherFilterInitialValues = {
  voucherTypePicker: '',
  statusPicker: '',
  startDate: null,
  endDate: null,
};

export const voucherInitialValues = {
  voucherTypeId: '',
  payee: '',
  description: '',
  billNumber: '',
  billAmount: '',
};

export const productionFilterInitialValues = {
  productPicker: '',
  startDate: null,
  endDate: null,
};

export const userProfileInitialValues = {
  firstName: '',
  lastName: '',
  countryCode: '94',
  phoneNumber: '',
};

export const passwordInitialValues = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
};

export const adminResetPasswordInitialValues = {
  newPassword: '',
  confirmPassword: '',
};

export const companyProfileInitialValues = {
  companyName: '',
  companyRegNo: '',
  country: '',
  addressLine1: '',
  addressLine2: '',
  postalCode: '',
  city: '',
  telephoneNumber: '',
  websiteUrl: '',
  email: '',
};

export const grnInitialValues = {
  id: '',
  vendor: '',
  invoiceNumber: '',
  invoiceAmount: '',
  notes: '',
  status: GRNStatus.NEW,
  grnItems: [
    {
      id: '',
      rawMaterialId: '',
      receivedQty: '',
      returnedQty: '',
      unitPrice: '',
    },
  ],
};

export const grnFilterInitialValues = {
  vendorPicker: '',
  statusPicker: '',
  startDate: null,
  endDate: null,
};

export const grnPaymentInitialValues = {
  id: '',
  grnId: '',
  receivedBy: '',
  paymentDate: new Date().toISOString().split('T')[0],
  amount: '',
  paymentMode: '' as PaymentMode | '',
  status: GRNPaymentStatus.PENDING_APPROVAL,
  chequeNumber: '',
  chequeDate: new Date().toISOString().split('T')[0],
  bankAccountId: '',
  transactionReference: '',
};

export const grnPaymentFilterInitialValues = {
  statusPicker: '',
  startDate: null,
  endDate: null,
};

export const orderPaymentInitialValues = {
  id: '',
  orderId: '',
  paymentDate: new Date().toISOString().split('T')[0],
  amount: '',
  paymentMode: '' as PaymentMode | '',
  status: 1,
  chequeNumber: '',
  chequeDate: new Date().toISOString().split('T')[0],
  chequeStatus: '',
  bankAccountId: '',
  transactionReference: '',
  notes: '',
};

export const orderPaymentFilterInitialValues = {
  statusPicker: '',
  startDate: null,
  endDate: null,
};

export const voucherPaymentInitialValues = {
  id: '',
  voucherId: '',
  receiverName: '',
  paymentDate: new Date().toISOString().split('T')[0],
  amount: '',
  paymentMode: '' as PaymentMode | '',
  chequeNumber: '',
  chequeDate: new Date().toISOString().split('T')[0],
  bankAccountId: '',
  transactionReference: '',
};
